import React from "react";
import { Card, Table } from "react-bootstrap";
import "../../components/trackResultSampleDisplay/trackResultSampleDisplay.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from "moment";
import isEqual from "react-fast-compare";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

export default class TrackResultSampleDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      samples: this.props.roomDetails.sample_areas,
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.roomName, this.props.roomName)) {
      this.setState({
        samples: this.props.roomDetails.sample_areas,
      });
    }
  }

  render() {
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1530,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              dots: true,
              infinite: false,                        
          }
      },
      {
          breakpoint: 1160,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: true,
              infinite: false,
          }
      },
      {
          breakpoint: 730,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              infinite: false,
          }
      }
      ],
    };
    return (
      <div className="carousel track-result-cord">
        <Row className="d-flex justify-content-between bd-highlight mb-2">
          <Col className="bd-highlight room-name ">{" "}{this.props.roomName ? this.props.roomName : null}</Col>
        </Row>
        {this.state.samples.length > 0 ? (
          <Slider {...settings}>
            {this.state.samples
              .reduce((prevSample, currSample) => {
                return {
                  ctResult: {
                    samples: [
                      ...prevSample.ctResult.samples,
                      ...currSample.ctResult.samples,
                    ],
                  },
                };
              })
              .ctResult.samples.sort((sample1, sample2) => {
                let date1 = new Date(sample1.sample__date_time);
                let date2 = new Date(sample2.sample__date_time);
                if (date1 < date2) return -1;
                if (date1 > date2) return 1;
                return 0;
              })
              .map((item) => {
                return (
                  <Card
                    className="sample-card"
                    style={{ height: "103px !importent" }}
                    // style={{ display: "inline-block !importent" }}
                  >
                    <Card.Body
                      className="d-flex  candidate-card"
                      style={{ padding: "0.5rem 0.3rem " }}
                    >
                      <div
                        className="track-result-sample-box"
                        style={{ backgroundColor: item.preFillColor }}
                      ></div>
                      <Table style={{ marginBottom: 0 }} borderless>
                        <tbody>
                          {item.sample__barcode ? (
                            <tr>
                              <td className="bodyCopy">
                                {item.sample__barcode}
                              </td>
                              <td className="bodyCopy text-align-end">
                                {moment(
                                  new Date(item.sample__date_time)
                                ).format("MMM D, YYYY HH:mm")}
                              </td>
                            </tr>
                          ) : null}
                          {item.sample__location ? (
                            item.sample__unit__unit_id ? (
                              <tr>
                                <td className="bodyCopy">
                                  {item.sample__location +
                                    "_" +
                                    item.sample__unit__unit_id}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td className="bodyCopy">
                                  {item.sample__location}
                                </td>
                              </tr>
                            )
                          ) : null}
                          {item.sample__type_of_analysis ? (
                            <tr>
                              <td className="bodyCopy">
                                {item.sample__type_of_analysis}
                              </td>
                            </tr>
                          ) : null}
                          {item.sample__type_of_samples ? (
                            <tr>
                              <td className="bodyCopy">
                                {item.sample__type_of_samples}
                              </td>
                            </tr>
                          ) : null}
                          {item.complex_type ? (
                            <tr>
                              <td className="bodyCopy text-bold">
                                {item.complex_type?
                                  `${item.complex_type}`
                                  :null}
                              </td>
                            </tr>
                          ) : null}
                          {item.novel_type ? (
                            <tr>
                              <td className="bodyCopy text-bold">
                                NT{item.novel_type}
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </Table>
                    </Card.Body>
                  </Card>
                );
              })}
          </Slider>
        ) : (
          <div className="no-msg-text">No results available for this room.</div>
        )}
      </div>
    );
  }
}
